import * as monaco from "monaco-editor";
const javaKeywords = [
  "abstract",
  "assert",
  "boolean",
  "break",
  "byte",
  "case",
  "catch",
  "char",
  "class",
  "const",
  "continue",
  "default",
  "do",
  "double",
  "else",
  "enum",
  "extends",
  "final",
  "finally",
  "float",
  "for",
  "goto",
  "if",
  "implements",
  "import",
  "instanceof",
  "int",
  "interface",
  "long",
  "native",
  "new",
  "package",
  "private",
  "protected",
  "public",
  "return",
  "short",
  "static",
  "strictfp",
  "super",
  "switch",
  "synchronized",
  "this",
  "throw",
  "throws",
  "transient",
  "try",
  "void",
  "volatile",
  "while",
  // Literals
  "true",
  "false",
  "null"
];
const javaBuiltinClasses = [
  "String",
  "Integer",
  "Double",
  "Float",
  "Long",
  "Boolean",
  "Character",
  "Math",
  "System",
  "Object",
  "Class",
  "Thread",
  "Exception",
  "RuntimeException",
  "ArrayList",
  "LinkedList",
  "HashMap",
  "HashSet",
  "Scanner",
  "Arrays",
  "Collections",
  "Date",
  "LocalDate",
  "LocalDateTime",
  "Optional",
  "StringBuilder",
  "StringBuffer"
];

const javaBuiltinMethods = [
  "println",
  "print",
  "parseInt",
  "parseDouble",
  "parseFloat",
  "parseLong",
  "toString",
  "equals",
  "hashCode",
  "length",
  "charAt",
  "substring",
  "add",
  "remove",
  "get",
  "set",
  "put",
  "contains",
  "size",
  "clear",
  "isEmpty",
  "sort",
  "split",
  "replace",
  "indexOf",
  "valueOf"
];

const cppKeyWords = [
  "alignas",
  "alignof",
  "and",
  "and_eq",
  "asm",
  "auto",
  "bitand",
  "bitor",
  "bool",
  "break",
  "case",
  "catch",
  "char",
  "char16_t",
  "char32_t",
  "class",
  "compl",
  "const",
  "constexpr",
  "const_cast",
  "continue",
  "decltype",
  "default",
  "delete",
  "do",
  "double",
  "dynamic_cast",
  "else",
  "enum",
  "explicit",
  "export",
  "extern",
  "false",
  "float",
  "for",
  "friend",
  "goto",
  "if",
  "inline",
  "int",
  "long",
  "mutable",
  "namespace",
  "new",
  "noexcept",
  "not",
  "not_eq",
  "nullptr",
  "operator",
  "or",
  "or_eq",
  "private",
  "protected",
  "public",
  "register",
  "reinterpret_cast",
  "return",
  "short",
  "signed",
  "sizeof",
  "static",
  "static_assert",
  "static_cast",
  "struct",
  "switch",
  "template",
  "this",
  "thread_local",
  "throw",
  "true",
  "try",
  "typedef",
  "typeid",
  "typename",
  "union",
  "unsigned",
  "using",
  "virtual",
  "void",
  "volatile",
  "wchar_t",
  "while",
  "xor",
  "xor_eq",
  "char8_t",
  "consteval",
  "constinit",
  "co_await",
  "co_return",
  "co_yield",
  "requires"
];

const cppBuiltinClasses = [
  "std::string",
  "std::vector",
  "std::map",
  "std::set",
  "std::unordered_map",
  "std::unordered_set",
  "std::pair",
  "std::tuple",
  "std::array",
  "std::list",
  "std::deque",
  "std::stack",
  "std::queue",
  "std::priority_queue",
  "std::bitset",
  "std::stringstream",
  "std::ifstream",
  "std::ofstream",
  "std::istringstream",
  "std::ostringstream",
  "std::mutex",
  "std::thread",
  "std::unique_ptr",
  "std::shared_ptr",
  "std::optional",
  "std::variant",
  "std::any"
];

const cppBuiltinMethods = [
  "push_back",
  "pop_back",
  "size",
  "length",
  "empty",
  "clear",
  "begin",
  "end",
  "find",
  "insert",
  "erase",
  "substr",
  "at",
  "front",
  "back",
  "resize",
  "swap",
  "sort",
  "reverse",
  "emplace",
  "emplace_back",
  "to_string",
  "stoi",
  "stod",
  "getline",
  "cin",
  "cout",
  "cerr",
  "clog",
  "flush",
  "max",
  "min",
  "abs",
  "pow",
  "sqrt",
  "rand",
  "srand",
  "time"
];

const cKeywords = [
  "auto",
  "break",
  "case",
  "char",
  "const",
  "continue",
  "default",
  "do",
  "double",
  "else",
  "enum",
  "extern",
  "float",
  "for",
  "goto",
  "if",
  "inline",
  "int",
  "long",
  "register",
  "restrict",
  "return",
  "short",
  "signed",
  "sizeof",
  "static",
  "struct",
  "switch",
  "typedef",
  "union",
  "unsigned",
  "void",
  "volatile",
  "while",
  "_Alignas",
  "_Alignof",
  "_Atomic",
  "_Bool",
  "_Complex",
  "_Generic",
  "_Imaginary",
  "_Noreturn",
  "_Static_assert",
  "_Thread_local"
];

const cBuiltinFunctions = [
  // stdio.h
  "printf",
  "scanf",
  "puts",
  "gets",
  "putchar",
  "getchar",
  "sprintf",
  "sscanf",
  "fopen",
  "fclose",
  "fread",
  "fwrite",
  "fprintf",
  "fscanf",

  // stdlib.h
  "malloc",
  "calloc",
  "realloc",
  "free",
  "exit",
  "atoi",
  "atof",
  "abs",
  "system",

  // string.h
  "strlen",
  "strcpy",
  "strncpy",
  "strcat",
  "strcmp",
  "strncmp",
  "strchr",
  "strstr",
  "memcpy",
  "memset",

  // math.h
  "sqrt",
  "pow",
  "sin",
  "cos",
  "tan",
  "log",
  "exp",
  "fabs",
  "ceil",
  "floor",

  // time.h
  "time",
  "clock",
  "difftime",
  "mktime",
  "asctime",
  "ctime",
  "gmtime",
  "localtime",

  // ctype.h
  "isalpha",
  "isdigit",
  "islower",
  "isupper",
  "isspace",
  "tolower",
  "toupper"
];

const cTypes = [
  "int",
  "char",
  "float",
  "double",
  "void",
  "size_t",
  "FILE",
  "struct",
  "union",
  "enum"
];

const pythonKeywords = [
  "False",
  "await",
  "else",
  "import",
  "pass",
  "None",
  "break",
  "except",
  "in",
  "raise",
  "True",
  "class",
  "finally",
  "is",
  "return",
  "and",
  "continue",
  "for",
  "lambda",
  "try",
  "as",
  "def",
  "from",
  "nonlocal",
  "while",
  "assert",
  "del",
  "global",
  "not",
  "with",
  "async",
  "elif",
  "if",
  "or",
  "yield"
];

const pythonBuiltins = [
  "abs",
  "all",
  "any",
  "ascii",
  "bin",
  "bool",
  "breakpoint",
  "bytearray",
  "bytes",
  "callable",
  "chr",
  "classmethod",
  "compile",
  "complex",
  "delattr",
  "dict",
  "dir",
  "divmod",
  "enumerate",
  "eval",
  "exec",
  "filter",
  "float",
  "format",
  "frozenset",
  "getattr",
  "globals",
  "hasattr",
  "hash",
  "help",
  "hex",
  "id",
  "input",
  "int",
  "isinstance",
  "issubclass",
  "iter",
  "len",
  "list",
  "locals",
  "map",
  "max",
  "memoryview",
  "min",
  "next",
  "object",
  "oct",
  "open",
  "ord",
  "pow",
  "print",
  "property",
  "range",
  "repr",
  "reversed",
  "round",
  "set",
  "setattr",
  "slice",
  "sorted",
  "staticmethod",
  "str",
  "sum",
  "super",
  "tuple",
  "type",
  "vars",
  "zip",
  "__import__"
];

const pythonMethods = [
  // str method
  "capitalize",
  "casefold",
  "center",
  "count",
  "encode",
  "endswith",
  "expandtabs",
  "find",
  "format",
  "index",
  "isalnum",
  "isalpha",
  "isdigit",
  "islower",
  "isspace",
  "istitle",
  "isupper",
  "join",
  "ljust",
  "lower",
  "lstrip",
  "partition",
  "replace",
  "rfind",
  "rindex",
  "rjust",
  "rpartition",
  "rsplit",
  "rstrip",
  "split",
  "splitlines",
  "startswith",
  "strip",
  "swapcase",
  "title",
  "upper",
  "zfill",

  //List Method
  "append",
  "clear",
  "copy",
  "count",
  "extend",
  "index",
  "insert",
  "pop",
  "remove",
  "reverse",
  "sort",

  //Dict Methods
  "clear",
  "copy",
  "fromkeys",
  "get",
  "items",
  "keys",
  "pop",
  "popitem",
  "setdefault",
  "update",
  "values",

  //Set Method
  "add",
  "clear",
  "copy",
  "difference",
  "discard",
  "intersection",
  "isdisjoint",
  "issubset",
  "issuperset",
  "pop",
  "remove",
  "symmetric_difference",
  "union",
  "update"
];

const csharpKeywords = [
  "abstract",
  "as",
  "base",
  "bool",
  "break",
  "byte",
  "case",
  "catch",
  "char",
  "checked",
  "class",
  "const",
  "continue",
  "decimal",
  "default",
  "delegate",
  "do",
  "double",
  "else",
  "enum",
  "event",
  "explicit",
  "extern",
  "false",
  "finally",
  "fixed",
  "float",
  "for",
  "foreach",
  "goto",
  "if",
  "implicit",
  "in",
  "int",
  "interface",
  "internal",
  "is",
  "lock",
  "long",
  "namespace",
  "new",
  "null",
  "object",
  "operator",
  "out",
  "override",
  "params",
  "private",
  "protected",
  "public",
  "readonly",
  "ref",
  "return",
  "sbyte",
  "sealed",
  "short",
  "sizeof",
  "stackalloc",
  "static",
  "string",
  "struct",
  "switch",
  "this",
  "throw",
  "true",
  "try",
  "typeof",
  "uint",
  "ulong",
  "unchecked",
  "unsafe",
  "ushort",
  "using",
  "virtual",
  "void",
  "volatile",
  "while",
  "yield"
];

const csharpTypes = [
  "Console",
  "Math",
  "String",
  "List",
  "DateTime",
  "Task",
  "int",
  "string",
  "bool"
];

const goKeywords = [
  "break",
  "case",
  "chan",
  "const",
  "continue",
  "default",
  "defer",
  "else",
  "fallthrough",
  "for",
  "func",
  "go",
  "goto",
  "if",
  "import",
  "interface",
  "map",
  "package",
  "range",
  "return",
  "select",
  "struct",
  "switch",
  "type",
  "var"
];

const goBuiltinFunctions = [
  "append",
  "cap",
  "close",
  "complex",
  "copy",
  "delete",
  "imag",
  "len",
  "make",
  "new",
  "panic",
  "print",
  "println",
  "real",
  "recover"
];

const goBuiltinTypes = [
  "bool",
  "byte",
  "complex64",
  "complex128",
  "error",
  "float32",
  "float64",
  "int",
  "int8",
  "int16",
  "int32",
  "int64",
  "rune",
  "string",
  "uint",
  "uint8",
  "uint16",
  "uint32",
  "uint64",
  "uintptr"
];

const symbols = /[=><!~?:&|+\-*\/\^%]+/;

const operators = [
  "=",
  ">",
  "<",
  "!",
  "~",
  "?",
  ":",
  "==",
  "<=",
  ">=",
  "!=",
  "&&",
  "||",
  "++",
  "--",
  "+",
  "-",
  "*",
  "/",
  "&",
  "|",
  "^",
  "%",
  "<<",
  ">>",
  ">>>",
  "+=",
  "-=",
  "*=",
  "/=",
  "&=",
  "|=",
  "^=",
  "%=",
  "<<=",
  ">>=",
  ">>>="
];

const jsKeywords = [
  "break",
  "case",
  "catch",
  "class",
  "const",
  "continue",
  "debugger",
  "default",
  "delete",
  "do",
  "else",
  "export",
  "extends",
  "finally",
  "for",
  "function",
  "if",
  "import",
  "in",
  "instanceof",
  "let",
  "new",
  "return",
  "super",
  "switch",
  "this",
  "throw",
  "try",
  "typeof",
  "var",
  "void",
  "while",
  "with",
  "yield",
  "enum",
  "await",
  "async",
  "static",
  "implements",
  "interface",
  "package",
  "private",
  "protected",
  "public",
  "string",
  "number"
];

const jsBuiltins = [
  "Array",
  "Boolean",
  "Date",
  "Error",
  "Function",
  "JSON",
  "Map",
  "Math",
  "Number",
  "Object",
  "Promise",
  "RegExp",
  "Set",
  "String",
  "Symbol",
  "WeakMap",
  "WeakSet",
  "console",
  "parseInt",
  "parseFloat",
  "isNaN",
  "isFinite",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "eval",
  "require",
  "module",
  "window",
  "document"
];

const jsMethods = [
  "push",
  "pop",
  "shift",
  "unshift",
  "map",
  "filter",
  "reduce",
  "forEach",
  "slice",
  "splice",
  "concat",
  "join",
  "indexOf",
  "includes",
  "replace",
  "toString",
  "charAt",
  "charCodeAt",
  "split",
  "trim",
  "toUpperCase",
  "toLowerCase"
];

export const TokenProvider: any = {
  myJava: {
    keywords: javaKeywords,
    tokenizer: {
      root: [
        [
          /[a-z_$][\w$]*/,
          { cases: { "@keywords": "keyword", "@default": "identifier" } }
        ],
        [/\d+/, "number"],
        [/"([^"\\]|\\.)*$/, "string.invalid"],
        [/"/, { token: "string.quote", bracket: "@open", next: "@string" }],
        [/\/\/.*$/, "comment"] // ← This is the fixed rule
      ],
      string: [
        [/[^\\"]+/, "string"],
        [/\\./, "string.escape.invalid"],
        [/"/, { token: "string.quote", bracket: "@close", next: "@pop" }]
      ],
      escapes: [
        [/\\(?:[abfnrtv\\"'])/, "string.escape"],
        [/\\x[0-9A-Fa-f]{2}/, "string.escape"],
        [/\\u[0-9A-Fa-f]{4}/, "string.escape"]
      ],
      comment: [
        [/[^\/*]+/, "comment"],
        [/\*\//, "comment", "@pop"],
        [/[\/*]/, "comment"]
      ]
    }
  },
  myCpp: {
    keywords: cppKeyWords,

    tokenizer: {
      root: [
        [
          /[a-zA-Z_]\w*/,
          {
            cases: {
              "@keywords": "keyword",
              "@default": "identifier"
            }
          }
        ],
        { include: "@whitespace" },
        [/\d+/, "number"],
        [/"/, { token: "string.quote", bracket: "@open", next: "@string" }],
        [/\/\/.*$/, "comment"],
        [/\/\*/, "comment", "@comment"]
      ],

      comment: [
        [/[^\/*]+/, "comment"],
        [/\*\//, "comment", "@pop"],
        [/[\/*]/, "comment"]
      ],

      string: [
        [/[^\\"]+/, "string"],
        [/\\./, "string.escape.invalid"],
        [/"/, { token: "string.quote", bracket: "@close", next: "@pop" }]
      ],

      whitespace: [[/\s+/, "white"]]
    }
  },
  myC: {
    keywords: cKeywords,
    tokenizer: {
      root: [
        [
          /[a-zA-Z_]\w*/,
          {
            cases: {
              "@keywords": "keyword",
              "@default": "identifier"
            }
          }
        ],
        { include: "@whitespace" },
        [/\d+/, "number"],
        [/"/, { token: "string.quote", bracket: "@open", next: "@string" }],
        [/\/\/.*$/, "comment"],
        [/\/\*/, "comment", "@comment"]
      ],

      comment: [
        [/[^\/*]+/, "comment"],
        [/\*\//, "comment", "@pop"],
        [/[\/*]/, "comment"]
      ],

      string: [
        [/[^\\"]+/, "string"],
        [/\\./, "string.escape.invalid"],
        [/"/, { token: "string.quote", bracket: "@close", next: "@pop" }]
      ],

      whitespace: [[/\s+/, "white"]]
    }
  },
  myPython: {
    keywords: pythonKeywords,
    builtins: pythonBuiltins,

    tokenizer: {
      root: [
        [
          /[a-zA-Z_]\w*/,
          {
            cases: {
              "@keywords": "keyword",
              "@builtins": "type.identifier",
              "@default": "identifier"
            }
          }
        ],
        [/\d+(\.\d+)?/, "number"],
        [/"/, { token: "string.quote", next: "@string" }],
        [/'/, { token: "string.quote", next: "@stringSingle" }],
        [/#.*$/, "comment"]
      ],

      string: [
        [/[^\\"]+/, "string"],
        [/\\./, "string.escape"],
        [/"/, { token: "string.quote", next: "@pop" }]
      ],

      stringSingle: [
        [/[^\\']+/, "string"],
        [/\\./, "string.escape"],
        [/'/, { token: "string.quote", next: "@pop" }]
      ]
    }
  },
  myCSharp: {
    keywords: csharpKeywords,
    typeKeywords: csharpTypes,

    tokenizer: {
      root: [
        [
          /[a-zA-Z_]\w*/,
          {
            cases: {
              "@keywords": "keyword",
              "@typeKeywords": "type",
              "@default": "identifier"
            }
          }
        ],
        [/\d+/, "number"],
        [/"/, { token: "string.quote", next: "@string" }],
        [/\/\/.*$/, "comment"],
        [/\/\*/, "comment", "@comment"]
      ],

      comment: [
        [/[^\/*]+/, "comment"],
        [/\*\//, "comment", "@pop"],
        [/[\/*]/, "comment"]
      ],

      string: [
        [/[^\\"]+/, "string"],
        [/\\./, "string.escape"],
        [/"/, { token: "string.quote", next: "@pop" }]
      ]
    }
  },
  myGo: {
    keywords: goKeywords,
    builtins: goBuiltinFunctions,
    types: goBuiltinTypes,

    tokenizer: {
      root: [
        [/\/\/.*$/, "comment"],
        [/\/\*/, "comment", "@comment"],
        [
          /[a-zA-Z_]\w*/,
          {
            cases: {
              "@keywords": "keyword",
              "@builtins": "predefined",
              "@types": "type",
              "@default": "identifier"
            }
          }
        ],
        { include: "@whitespace" },
        [/[{}()\[\]]/, "@brackets"],
        [/[<>]/, "@brackets"],
        [
          symbols,
          {
            cases: {
              "@operators": "operator",
              "@default": ""
            }
          }
        ],
        [/\d+(\.\d+)?/, "number"],
        [/".*?"/, "string"]
      ],
      comment: [
        [/[^\/*]+/, "comment"],
        [/\*\//, "comment", "@pop"],
        [/[\/*]/, "comment"]
      ],

      whitespace: [[/\s+/, "white"]]
    },

    operators // 👈 expose it here so it can be used with @operators
  },
  myTypeScript: {
    keywords: [
      ...jsKeywords,
      "type",
      "namespace",
      "abstract",
      "declare",
      "readonly",
      "keyof",
      "infer",
      "as"
    ],
    tokenizer: {
      root: [
        [
          /[a-zA-Z_$][\w$]*/,
          { cases: { "@keywords": "keyword", "@default": "identifier" } }
        ],
        [/\d+/, "number"],
        [
          /"/,
          { token: "string.quote", bracket: "@open", next: "@stringDouble" }
        ],
        [
          /'/,
          { token: "string.quote", bracket: "@open", next: "@stringSingle" }
        ],
        [
          /`/,
          { token: "string.quote", bracket: "@open", next: "@stringBacktick" }
        ],
        [/\/\/.*$/, "comment"],
        [/\/\*/, "comment", "@comment"]
      ],
      comment: [
        [/[^\/*]+/, "comment"],
        [/\*\//, "comment", "@pop"],
        [/[\/*]/, "comment"]
      ],
      stringDouble: [
        [/[^\\"]+/, "string"],
        [/\\./, "string.escape"],
        [/"/, { token: "string.quote", next: "@pop" }]
      ],
      stringSingle: [
        [/[^\\']+/, "string"],
        [/\\./, "string.escape"],
        [/'/, { token: "string.quote", next: "@pop" }]
      ],
      stringBacktick: [
        [/[^\\`]+/, "string"],
        [/\\./, "string.escape"],
        [/`/, { token: "string.quote", next: "@pop" }]
      ]
    }
  }
};

export const CompletionItemProvider: any = {
  myJava: {
    triggerCharacters: [" ", "."],
    provideCompletionItems: (model: any, position: any) => {
      // Get the current word at the cursor position
      const word = model.getWordUntilPosition(position);
      const range: monaco.IRange = {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        startColumn: word.startColumn,
        endColumn: word.endColumn
      };

      const keywordSuggestions: monaco.languages.CompletionItem[] =
        javaKeywords.map((keyword) => ({
          label: keyword,
          kind: monaco.languages.CompletionItemKind.Keyword,
          insertText: keyword,
          detail: "Java keyword",
          range
        }));

      const classSuggestions = javaBuiltinClasses.map((cls) => ({
        label: cls,
        kind: monaco.languages.CompletionItemKind.Class,
        insertText: cls,
        detail: "Java built-in class",
        range
      }));

      const methodSuggestions = javaBuiltinMethods.map((method) => ({
        label: method,
        kind: monaco.languages.CompletionItemKind.Method,
        insertText: method + "()",
        insertTextRules:
          monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        detail: "Java built-in method",
        range
      }));

      return {
        suggestions: [
          ...keywordSuggestions,
          ...classSuggestions,
          ...methodSuggestions
        ]
      };
    }
  },
  myCpp: {
    triggerCharacters: [" ", ".", ":"],
    provideCompletionItems: (model: any, position: any) => {
      const word = model.getWordUntilPosition(position);
      const range: monaco.IRange = {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        startColumn: word.startColumn,
        endColumn: word.endColumn
      };

      const keywordSuggestions = cppKeyWords.map((keyword) => ({
        label: keyword,
        kind: monaco.languages.CompletionItemKind.Keyword,
        insertText: keyword,
        detail: "C++ keyword",
        range
      }));

      const methodSuggestions = cppBuiltinMethods.map((method) => ({
        label: method,
        kind: monaco.languages.CompletionItemKind.Method,
        insertText: `${method}($0)`,
        insertTextRules:
          monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        detail: "C++ built-in method",
        range
      }));

      const classSuggestions = cppBuiltinClasses.map((cls) => ({
        label: cls,
        kind: monaco.languages.CompletionItemKind.Class,
        insertText: cls,
        detail: "C++ standard class",
        range
      }));

      return {
        suggestions: [
          ...keywordSuggestions,
          ...classSuggestions,
          ...methodSuggestions
        ]
      };
    }
  },
  myC: {
    triggerCharacters: [" ", ".", ">"],
    provideCompletionItems: (model: any, position: any) => {
      const word = model.getWordUntilPosition(position);
      const range: monaco.IRange = {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        startColumn: word.startColumn,
        endColumn: word.endColumn
      };

      const keywordSuggestions = cKeywords.map((keyword) => ({
        label: keyword,
        kind: monaco.languages.CompletionItemKind.Keyword,
        insertText: keyword,
        detail: "C keyword",
        range
      }));

      const methodSuggestions = cBuiltinFunctions.map((func) => ({
        label: func,
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: `${func}($0)`,
        insertTextRules:
          monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        detail: "C standard library function",
        range
      }));

      const typeSuggestions = cTypes.map((type) => ({
        label: type,
        kind: monaco.languages.CompletionItemKind.TypeParameter,
        insertText: type,
        detail: "C type",
        range
      }));

      return {
        suggestions: [
          ...keywordSuggestions,
          ...methodSuggestions,
          ...typeSuggestions
        ]
      };
    }
  },
  myPython: {
    triggerCharacters: [" ", ".", "("],
    provideCompletionItems: (model: any, position: any) => {
      const word = model.getWordUntilPosition(position);
      const range: monaco.IRange = {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        startColumn: word.startColumn,
        endColumn: word.endColumn
      };

      const keywordSuggestions = pythonKeywords.map((keyword) => ({
        label: keyword,
        kind: monaco.languages.CompletionItemKind.Keyword,
        insertText: keyword,
        detail: "Python keyword",
        range
      }));

      const builtinSuggestions = pythonBuiltins.map((fn) => ({
        label: fn,
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: fn + (fn === "print" ? "($0)" : ""),
        insertTextRules:
          monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        detail: "Built-in function",
        range
      }));

      const methodSuggestions = pythonMethods.map((method) => ({
        label: method,
        kind: monaco.languages.CompletionItemKind.Method,
        insertText: method + "()",
        insertTextRules:
          monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        detail: "Python built-in method",
        range
      }));
      return {
        suggestions: [
          ...keywordSuggestions,
          ...builtinSuggestions,
          ...methodSuggestions
        ]
      };
    }
  },
  myCSharp: {
    triggerCharacters: [" ", ".", "(", ":"],
    provideCompletionItems: (model: any, position: any) => {
      const word = model.getWordUntilPosition(position);
      const range: monaco.IRange = {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        startColumn: word.startColumn,
        endColumn: word.endColumn
      };

      const keywordSuggestions = csharpKeywords.map((keyword) => ({
        label: keyword,
        kind: monaco.languages.CompletionItemKind.Keyword,
        insertText: keyword,
        detail: "C# keyword",
        range
      }));

      const typeSuggestions = csharpTypes.map((type) => ({
        label: type,
        kind: monaco.languages.CompletionItemKind.Class,
        insertText: type,
        detail: "C# type",
        range
      }));

      const snippetSuggestions = [
        {
          label: "main",
          kind: monaco.languages.CompletionItemKind.Snippet,
          insertText: [
            "public static void Main(string[] args)",
            "{",
            "\t$0",
            "}"
          ].join("\n"),
          insertTextRules:
            monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          detail: "Main method snippet",
          documentation: "C# main method entry point",
          range
        }
      ];

      return {
        suggestions: [
          ...keywordSuggestions,
          ...typeSuggestions,
          ...snippetSuggestions
        ]
      };
    }
  },
  myGo: {
    triggerCharacters: [".", " ", "("],
    provideCompletionItems: (model: any, position: any) => {
      const word = model.getWordUntilPosition(position);
      const range: monaco.IRange = {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        startColumn: word.startColumn,
        endColumn: word.endColumn
      };

      const keywordSuggestions = goKeywords.map((keyword) => ({
        label: keyword,
        kind: monaco.languages.CompletionItemKind.Keyword,
        insertText: keyword,
        detail: "Go keyword",
        range
      }));

      const typeSuggestions = goBuiltinTypes.map((type) => ({
        label: type,
        kind: monaco.languages.CompletionItemKind.TypeParameter,
        insertText: type,
        detail: "Go type",
        range
      }));

      const funcSuggestions = goBuiltinFunctions.map((fn) => ({
        label: fn,
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: fn + "($0)",
        insertTextRules:
          monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        detail: "Go built-in function",
        range
      }));

      return {
        suggestions: [
          ...keywordSuggestions,
          ...typeSuggestions,
          ...funcSuggestions
        ]
      };
    }
  },
  myTypeScript: {
    triggerCharacters: [".", " "],
    provideCompletionItems: (model: any, position: any) => {
      const word = model.getWordUntilPosition(position);
      const range: monaco.IRange = {
        startLineNumber: position.lineNumber,
        endLineNumber: position.lineNumber,
        startColumn: word.startColumn,
        endColumn: word.endColumn
      };

      const keywordSuggestions = [
        ...jsKeywords,
        "type",
        "namespace",
        "abstract",
        "declare",
        "readonly",
        "keyof",
        "infer",
        "as"
      ].map((k) => ({
        label: k,
        kind: monaco.languages.CompletionItemKind.Keyword,
        insertText: k,
        detail: "TS keyword",
        range
      }));

      const builtinSuggestions = jsBuiltins.map((b) => ({
        label: b,
        kind: monaco.languages.CompletionItemKind.Class,
        insertText: b,
        detail: "TS built-in",
        range
      }));

      const methodSuggestions = jsMethods.map((m) => ({
        label: m,
        kind: monaco.languages.CompletionItemKind.Method,
        insertText: m + "()",
        insertTextRules:
          monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        detail: "TS built-in method",
        range
      }));

      const snippetSuggestions = [
        {
          label: "starterCode",
          kind: monaco.languages.CompletionItemKind.Snippet,
          insertText: `// Write your code here\nconsole.log("Hello, TypeScript!");`,
          insertTextRules:
            monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
          detail: "TypeScript starter code",
          range
        }
      ];

      return {
        suggestions: [
          ...keywordSuggestions,
          ...builtinSuggestions,
          ...methodSuggestions,
          ...snippetSuggestions
        ]
      };
    }
  }
};

export const languageConfig: monaco.languages.LanguageConfiguration = {
  comments: {
    lineComment: "//",
    blockComment: ["/*", "*/"]
  },
  autoClosingPairs: [
    { open: "(", close: ")" },
    { open: "[", close: "]" },
    { open: "{", close: "}" },
    { open: '"', close: '"', notIn: ["string"] },
    { open: "'", close: "'", notIn: ["string", "comment"] },
    { open: "`", close: "`" }
  ],
  surroundingPairs: [
    { open: "(", close: ")" },
    { open: "[", close: "]" },
    { open: "{", close: "}" },
    { open: '"', close: '"' },
    { open: "'", close: "'" },
    { open: "`", close: "`" }
  ],
  brackets: [
    ["{", "}"],
    ["[", "]"],
    ["(", ")"]
  ] as [string, string][]
};

export function getLanguageConfig(
  lang: string
): monaco.languages.LanguageConfiguration {
  const commonConfig = {
    autoClosingPairs: [],
    surroundingPairs: [],
    brackets: []
  };

  const commentConfigs: Record<
    string,
    { comments: monaco.languages.LanguageConfiguration["comments"] }
  > = {
    myGo: {
      comments: { lineComment: "//", blockComment: ["/*", "*/"] }
    },
    myJava: {
      comments: { lineComment: "//", blockComment: ["/*", "*/"] }
    },
    myCpp: {
      comments: { lineComment: "//", blockComment: ["/*", "*/"] }
    },
    myC: {
      comments: { lineComment: "//", blockComment: ["/*", "*/"] }
    },
    myCSharp: {
      comments: { lineComment: "//", blockComment: ["/*", "*/"] }
    },
    myPython: {
      comments: { lineComment: "#" }
    },
    myTypeScript: {
      comments: { lineComment: "//", blockComment: ["/*", "*/"] }
    }
  };

  return {
    ...commonConfig,
    ...commentConfigs[lang]
  };
}
